const FAQ_CATEGORY_LOADING = "FAQ_CATEGORY_LOADING";
const FAQ_CATEGORY_SUCCESS = "FAQ_CATEGORY_SUCCESS";
const FAQ_CATEGORY_ERROR = "FAQ_CATEGORY_ERROR";

export {
    FAQ_CATEGORY_LOADING,
    FAQ_CATEGORY_ERROR,
    FAQ_CATEGORY_SUCCESS,
};